import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

export default function ProtectedAdminRoute() {
    const { isAuthenticated, user } = useSelector(state => state.root);
    if (!isAuthenticated) return <Navigate to="/" replace />;
    if (user.type === 'admin') return <Outlet />;
    return <Navigate to={user.type === 'teacher' ? '/teacher' : '/student'} replace />;
}
